import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from '../i18n';
import { getPageCopy, loadCommonCopy } from '../i18n/runtime-loader';

function getPageSlug(pathname: string): string {
  if (pathname === '/') return 'home';
  if (pathname.startsWith('/news/')) return 'news-detail';
  if (pathname.startsWith('/products/cex')) return 'products-cex';
  if (pathname.startsWith('/products/rwa')) return 'products-rwa';
  if (pathname.startsWith('/products/wallet')) return 'products-wallet';
  if (pathname.startsWith('/products/defi')) return 'products-defi';
  if (pathname.startsWith('/products/mining')) return 'products-mining';
  if (pathname.startsWith('/products')) return 'products';
  if (pathname.startsWith('/about')) return 'about';
  if (pathname.startsWith('/advantages')) return 'advantages';
  if (pathname.startsWith('/news')) return 'news';
  if (pathname.startsWith('/contact')) return 'contact';
  return 'common';
}

export function usePageCopy(): void {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const locale = i18n.language;
        await loadCommonCopy(locale);
        if (cancelled) return;
        await getPageCopy(getPageSlug(location.pathname), locale);
      } catch (err) {
        console.warn('[i18n] runtime copy load failed', err);
      }
    };

    run();

    const onLangChanged = (lng: string) => {
      void loadCommonCopy(lng)
        .then(() => getPageCopy(getPageSlug(location.pathname), lng))
        .catch((err) => console.warn('[i18n] runtime copy reload failed', err));
    };

    i18n.on('languageChanged', onLangChanged);
    return () => {
      cancelled = true;
      i18n.off('languageChanged', onLangChanged);
    };
  }, [location.pathname]);
}
